module.exports = __webpack_public_path__ + "static/works-spotigy-site-3affe8c3986fa49686449c38ac70bd0b.png";